document.addEventListener('DOMContentLoaded', () => {
    const header = document.querySelector('.new-header');
            if (window.scrollY == 0) {
              header.classList.remove('header--white');
            }
    window.addEventListener('scroll', () => {
        if (window.scrollY > 0) {
            if (!header.classList.contains('header--white')) {
                header.classList.add('header--white');
            }
        }
        else {
            header.classList.remove('header--white');
        }
    })
});